import { useContext, useMemo } from 'react';
import { TableTab } from '@models/document/IDocumentScheme';
import { LinkedDocsActionsService } from '@services/actions/LinkedDocsActionsService';
import { DocumentLinksService } from '@services/DocumentLinksService';
import { useParams } from 'react-router';
import { DocumentRuntimeContext, isDocumentRuntimeReadOnly } from '@/context/DocumentRuntimeContext';
import DocumentLinksGrid from './DocumentLinksGrid';

export interface IDocumentLinksTableProps {
    linkId?: string;
    linkTable: TableTab;
    docId?: string;
}

const DocumentLinksTable = ({ linkId, linkTable, docId }: IDocumentLinksTableProps) => {
    const { id, actId } = useParams();
    const runtime = useContext(DocumentRuntimeContext);
    const readOnly = isDocumentRuntimeReadOnly(runtime);
    const serviceGrid = useMemo(
        () =>
            runtime.mode === 'supportPreview'
                ? runtime.dataSource?.linksService
                : new DocumentLinksService(docId, actId, id),
        [actId, docId, id, runtime.dataSource?.linksService, runtime.mode],
    );
    const actionService = useMemo(() => (readOnly ? undefined : new LinkedDocsActionsService()), [readOnly]);

    if (!serviceGrid) {
        return <div role="alert">Session-scoped источник связей не настроен.</div>;
    }

    const schemeDocId = docId ?? '-1';
    const sourcePath =
        schemeDocId === '-1' && actId
            ? `/document/linkSchemeByAction/${actId}/${linkTable.key}`
            : `/document/linkScheme/${schemeDocId}/${linkTable.key}`;

    return (
        <div className="links-table" data-testid={linkId ? `link-table-${linkId}` : undefined}>
            <DocumentLinksGrid
                key={`grid_${linkTable.key}`}
                dataKey={linkTable.key}
                title={linkTable.name}
                service={serviceGrid}
                actionService={actionService}
                linkPrefix={readOnly ? undefined : '/document'}
                readOnly={readOnly}
                schemeDebug={{
                    title: linkTable.name,
                    tableKey: linkTable.key,
                    visibilityRules: linkTable.visibilityRules,
                    sourcePath,
                }}
            />
        </div>
    );
};

export default DocumentLinksTable;
